import React from 'react';
import injectSheet from 'react-jss';
import { RadioButton, RadioButtonGroup } from 'material-ui';
import Connections, { styles as connectionStyles } from './connections';

const SearchFor = ({ companyType, onChange, classes: css }) => {
  return (
    <div style={{ marginTop: '-15px' }}>
      <Connections />
      <div
        style={connectionStyles.title}
        onClick={() => {
          this.props.push('/partner-finder/results');
        }}
      >
        Partner Search
      </div>
      <div className={`searchCompanyType ${css.searchForText}`} style={{ marginTop: '16px' }}>
        I'm searching for:
      </div>
      <RadioButtonGroup
        name="type"
        className={css.radioGroup}
        defaultSelected={companyType}
        onChange={(_, type) => onChange(type)}
      >
        <RadioButton value="Contractor" className={css.radioButton} label="Buyers / Agents" />
        <RadioButton value="Supplier" className={css.radioButton} label="Suppliers" />
        <RadioButton value="DMOs" className={css.radioButton} label="DMO's" />
        <RadioButton value="TechAndServices" className={css.radioButton} label="Tech & Services" />
      </RadioButtonGroup>
    </div>
  );
};

export default injectSheet({
  searchForText: { color: 'black', marginLeft: '16px' },
  radioGroup: { padding: '10px 16px' },
  radioButton: { marginBottom: '10px' },
})(SearchFor);



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/search-widgets/search-for-company-type.jsx